import { useBreakpoints } from "@vueuse/core";
import themeConfig from "@root/theme.config";

export function useRothcoBreakpoints(){

    let rothcoBreakpointValues = themeConfig.theme.breakpoints;
    let breakpoints = useBreakpoints({
        tablet: rothcoBreakpointValues['breakpoint-tablet'],
        laptop: rothcoBreakpointValues['breakpoint-desktop'],
        desktop: rothcoBreakpointValues['breakpoint-desktop-md'],
    })

    return breakpoints;
}